import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";

import { FixingSourceLookupService } from "./FixingSourceLookupService";
import { PrimaryLookupService } from "../../impl/PrimaryLookupService";
import { IFixingSourcePromiseLookupService } from "../IFixingSourcePromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";

import { CubiqWorker } from "../../../worker/CubiqWorker";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class FixingSourcePrimaryLookupService
  extends PrimaryLookupService<string, CubiqTS.NdfSourceImpl>
  implements IFixingSourcePromiseLookupService
{
  constructor(
    protected base: FixingSourceLookupService,
    protected factory: ServiceMessageBrokerFactory,
    protected cubiqWorker: CubiqWorker,
  ) {
    super(base, factory, CubiqTS.NdfSourceImpl, cubiqWorker, "NdfSourceImpl");

    cubiqWorker.isAuth(`${this.constructor.name}`).then(
      () => {
        let fixingSourceObservable = cubiqWorker.primeStaticData<CubiqTS.NdfSourceImpl>(
          CubiqTS.NdfSourceImpl.name,
        );

        fixingSourceObservable.subscribe(
          (fixingSource: CubiqTS.NdfSourceImpl[]) => {
            this.base.prime(fixingSource);
          },
          (error: Error) => {
            console.debug("FixingSource prime failed");
            this._primed.reject(error);
          },
          () => {
            this._primed.resolve(true);
          },
        );
      },
      (reason) => {
        console.debug("FixingSourcePrimaryLookupService: Failed to prime: " + reason);

        this._primed.resolve(false);
      },
    );

    this.broker.registerMethod(
      "getFixingSource",
      [PRIMITIVE],
      this.getFixingSource.bind(this),
      this.VALUE,
    );
    this.broker.registerMethod(
      "getFixingSourcesForPair",
      [PRIMITIVE],
      this.getFixingSourcesForPair.bind(this),
      PRIMITIVE,
    );
    this.broker.registerMethod(
      "getFixingSourceInPair",
      [PRIMITIVE, PRIMITIVE],
      this.getFixingSourceInPair.bind(this),
      PRIMITIVE,
    );
    this.broker.registerMethod(
      "getAllAdaptedFixingSources",
      [],
      this.getAllAdaptedFixingSources.bind(this),
      PRIMITIVE,
    );
  }

  getFixingSource(id: string): Promise<CubiqTS.NdfSourceImpl> {
    return new Promise<CubiqTS.NdfSourceImpl>((res, rej) => {
      res(this.base.getFixingSource(id));
    });
  }

  getFixingSourceInPair(fixingSourceCd: string, pair: string): Promise<any> {
    return new Promise<any>((res, rej) => {
      this._primed.get().then((value) => {
        res(this.base.getFixingSourceInPair(fixingSourceCd, pair));
      });
    });
  }

  getFixingSourcesForPair(pair: string): Promise<Array<any>> {
    return new Promise<any>((res, rej) => {
      this._primed.get().then((value) => {
        res(this.base.getFixingSourcesForPair(pair));
      });
    });
  }
  getAllAdaptedFixingSources(): Promise<Array<any>> {
    return new Promise<any>((res, rej) => {
      this._primed.get().then((value) => {
        res(this.base.getAllAdaptedFixingSources());
      });
    });
  }
}
